"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

var _axios = _interopRequireDefault(require("axios"));

var _useTranslation = _interopRequireDefault(require("../TranslationProvider/useTranslation"));

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

var reducer = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case 'START_FETCHING':
      return {
        loading: true
      };

    case 'CANCEL_FETCH':
      return {
        option: state.option
      };

    case 'FETCH_ERROR':
      return {
        error: action.error
      };

    case 'FETCH_SUCCESS':
      return {
        option: action.option,
        loading: false
      };

    default:
      return state;
  }
};

var useGeocoding = function useGeocoding(lat, lng, onError) {
  var _useReducer = (0, _react.useReducer)(reducer, {}),
      _useReducer2 = (0, _slicedToArray2["default"])(_useReducer, 2),
      state = _useReducer2[0],
      dispatch = _useReducer2[1];

  var t = (0, _useTranslation["default"])();
  (0, _react.useEffect)(function () {
    if (typeof lat !== 'number' || typeof lng !== 'number') {
      return dispatch({
        type: 'CANCEL_FETCH'
      });
    }

    var cancelToken = _axios["default"].CancelToken.source();

    dispatch({
      type: 'START_FETCHING'
    });

    _axios["default"].get('https://geo.api.gouv.fr/communes', {
      params: {
        lat: lat,
        lon: lng,
        fields: 'nom,codeDepartement,centre',
        format: 'json',
        geometry: 'centre'
      },
      cancelToken: cancelToken.token
    }).then(function (response) {
      var _response$data;

      var option = (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data[0];

      if (option) {
        return dispatch({
          option: option,
          type: 'FETCH_SUCCESS'
        });
      }

      dispatch({
        type: 'FETCH_ERROR',
        error: new Error(t('cannot_geolocate'))
      });
    })["catch"](function (e) {
      if (!_axios["default"].isCancel(e)) {
        /** Notify bugsnag about this error */
        onError === null || onError === void 0 ? void 0 : onError('Geocoding failed', {
          severity: 'info',
          metaData: {
            lat: lat,
            lng: lng
          }
        });
        dispatch({
          type: 'FETCH_ERROR',
          error: e
        });
      }
    });

    return function () {
      return cancelToken.cancel();
    };
  }, [lat, lng]);
  return state;
};

__signature__(useGeocoding, "useReducer{[state, dispatch]({})}\nuseTranslation{t}\nuseEffect{}", function () {
  return [_useTranslation["default"]];
});

var _default = useGeocoding;
var _default2 = _default;
exports["default"] = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(reducer, "reducer", "/builds/bA1zbJom/0/gojob/ui-bits/src/PlacesAutocomplete/AutoLocation/useGeocoding.ts");
  reactHotLoader.register(useGeocoding, "useGeocoding", "/builds/bA1zbJom/0/gojob/ui-bits/src/PlacesAutocomplete/AutoLocation/useGeocoding.ts");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/PlacesAutocomplete/AutoLocation/useGeocoding.ts");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();